module.exports = __webpack_public_path__ + "static/media/crack-the-code.6101734c.png";